module.exports = __webpack_public_path__ + "img/logo.422d3149.png";